import { PermissionCode } from '../../../shared/enums/permission-code';

export const SourceTypes = [
  {
    id: 1,
    label: 'ACC Business Records',
    apiValue: ['DNB', 'CRM_DNB'],
    value: 'ACC_ALL_SOURCES',
    permissions: PermissionCode.ACCESS_DNB,
  },
  {
    id: 2,
    label: 'WNCSBI',
    apiValue: ['CRF'],
    value: 'WNCSBI_APPS',
    permissions: PermissionCode.ACCESS_CRF,
  },
  {
    id: 3,
    label: 'Referrals',
    apiValue: ['CUSTOM'],
    value: 'CUSTOM_BUSINESS_RECORDS',
    permissions: PermissionCode.CUSTOM_BUSINESS_RECORD,
  },
  {
    id: 4,
    label: 'Data Axle Records',
    apiValue: ['DATA_AXLE'],
    value: 'DATA_AXLE',
    permissions: PermissionCode.ACCESS_DATA_AXLE,
  },
  {
    id: 5,
    label: 'Veteran Loan Fund',
    apiValue: ['VLF'],
    value: 'VLF',
    permissions: PermissionCode.ACCESS_VLF,
  },

  {
    id: 6,
    label: 'Inquiries',
    apiValue: ['PUBLIC'],
    value: 'PUBLIC',
    permissions: PermissionCode.ACCESS_DEEPROOTS,
  },
  {
    id: 7,
    label: 'Business Records',
    apiValue: ['SME'],
    value: 'SME',
    permissions: PermissionCode.ACCESS_DEEPROOTS,
  },
];

export class SourceTypeConverter {
  static getApiSources(sources: string): string | undefined {
    if (!sources) return undefined;
    const selectedValues = sources.split(',');
    const apiValues = [];
    for (const selectedValue of selectedValues) {
      const source = SourceTypes.find(
        (source) => source.value === selectedValue,
      );
      if (source) {
        apiValues.push(...source.apiValue);
      } else {
        // If not found by value, assume it's already an API value
        apiValues.push(selectedValue);
      }
    }
    return apiValues.join(',') || undefined;
  }
}
